"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOptions = exports.getDateTimeFormatter = void 0;
const FormatterUtils_1 = require("../FormatterUtils");
function getDateTimeFormatter(dateTimeOptions) {
    (0, FormatterUtils_1.validateLocale)(dateTimeOptions.locale);
    const dateTimeFormatOptions = exports.transformOptions(dateTimeOptions);
    return new Intl.DateTimeFormat(dateTimeOptions.locale, dateTimeFormatOptions);
}
exports.getDateTimeFormatter = getDateTimeFormatter;
function transformOptions(dateTimeOptions) {
    const dateTimeFormatOptions = {};
    dateTimeFormatOptions.timeZone = dateTimeOptions.timeZone;
    dateTimeFormatOptions.timeZoneName = dateTimeOptions.timeZoneName;
    dateTimeFormatOptions.hour12 = dateTimeOptions.hour12;
    dateTimeFormatOptions.dateStyle = dateTimeOptions.dateStyle;
    dateTimeFormatOptions.timeStyle = dateTimeOptions.timeStyle;
    dateTimeFormatOptions.weekday = dateTimeOptions.weekday;
    dateTimeFormatOptions.year = dateTimeOptions.year;
    dateTimeFormatOptions.month = dateTimeOptions.month;
    dateTimeFormatOptions.day = dateTimeOptions.day;
    dateTimeFormatOptions.hour = dateTimeOptions.hour;
    dateTimeFormatOptions.minute = dateTimeOptions.minute;
    dateTimeFormatOptions.second = dateTimeOptions.second;
    return dateTimeFormatOptions;
}
exports.transformOptions = transformOptions;
//# sourceMappingURL=DateTimeUtils.js.map